var _rect, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdjustGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.4134,
    height: 18,
    transform: "translate(0 0.111328)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20337 18.1113L3.20337 1.11133",
    stroke: "#9296AC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6427 18.1113L7.6427 1.11133",
    stroke: "#9296AC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0822 18.1113L12.0822 1.11133",
    stroke: "#9296AC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5215 18.1113L16.5215 1.11133",
    stroke: "#9296AC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.20313,
    cy: 2.65678,
    rx: 1.47974,
    ry: 1.54545,
    fill: "white",
    stroke: "#9296AC",
    strokeWidth: 1.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.64259,
    cy: 13.4751,
    rx: 1.47974,
    ry: 1.54545,
    fill: "white",
    stroke: "#9296AC",
    strokeWidth: 1.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.0819,
    cy: 4.97514,
    rx: 1.47974,
    ry: 1.54545,
    fill: "white",
    stroke: "#9296AC",
    strokeWidth: 1.2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.521,
    cy: 9.61186,
    rx: 1.47974,
    ry: 1.54545,
    fill: "white",
    stroke: "#9296AC",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustGray);
export default __webpack_public_path__ + "static/media/adjustGray.5640ed3e33486023602b97470dee54ff.svg";
export { ForwardRef as ReactComponent };